import { Component, ElementRef, EventEmitter, Output, Input, ViewEncapsulation, Renderer2, AfterContentChecked, OnDestroy} from '@angular/core';
import { WindowService } from 'src/shared/providers/window.service';

const BREAK_LARGE_RESOLUTION = 884;

@Component({
    selector: 'tidy-wrapper',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./wrapper.component.scss'],
    template: `
    <ng-content></ng-content>
  `,
    standalone: false
})

export  class WrapperComponent implements AfterContentChecked {
  _contentHeight;
  @Output() contentHeight: EventEmitter<number> = new EventEmitter<number>();
  @Input() hasBottomNav = false;

  constructor(
    private el : ElementRef,
    private renderer : Renderer2,
    private windowService: WindowService
  ) {
  }

  ngAfterContentChecked() {
    const elementHeight = this.el.nativeElement.offsetHeight;
    if(this._contentHeight !== elementHeight) {
      this._contentHeight = elementHeight;
      this.contentHeight.emit(this._contentHeight);
      this.setPlatformClass();
    }
  }

  setPlatformClass(){
    if(this.isDesktopRes || !this.hasBottomNav){
      this.renderer.addClass(this.el.nativeElement, 'desktop');
      this.renderer.removeClass(this.el.nativeElement, 'mobile');
    } else {
      this.renderer.addClass(this.el.nativeElement, 'mobile');
      this.renderer.removeClass(this.el.nativeElement, 'desktop');
    }
  }

  public get isDesktopRes(): boolean {
    return this.windowService.windowSize > BREAK_LARGE_RESOLUTION;
  }
}
